import type { GestureTracker } from './workerUpdate';

/**
 * Unsaved edits outside the picker (the check-in card's edit mode): while any are open, the
 * worker-update reload waits and closing or reloading the page asks the browser's confirmation.
 */
const open = new Set<symbol>();
let pending: (() => void) | null = null;

function onBeforeUnload(event: BeforeUnloadEvent): void {
  event.preventDefault();
}

/** Mark one editor dirty (`true`) or clean; returns nothing. Call with `false` on unmount. */
export function setUnsavedEdit(token: symbol, dirty: boolean): void {
  const before = open.size;
  if (dirty) open.add(token);
  else open.delete(token);
  if (before === 0 && open.size > 0) window.addEventListener('beforeunload', onBeforeUnload);
  if (before > 0 && open.size === 0) {
    window.removeEventListener('beforeunload', onBeforeUnload);
    const run = pending;
    pending = null;
    run?.();
  }
}

export function trackUnsavedEdits(): GestureTracker {
  return {
    active: () => open.size > 0,
    onIdle(callback) {
      pending = callback;
    },
  };
}
